import "./style.css";

export default class SelectBox {
  static selector = ".select-box";

  constructor(block) {
    this.block = block;
    this.select = this.block.querySelector("select");
    this.nativeOptions = [...this.select.options];
    this.display = this.block.querySelector(".select-box__display");
    this.optionsList = this.block.querySelector(".select-box__options");
    this.options = [...this.block.querySelectorAll(".select-box__option")];
    this.multiple = this.select.hasAttribute("multiple");
    this.placeholder = this.block.dataset.placeholder;
  }

  open = () => {
    // refresh selected items
    this.options.forEach(o =>
      o.classList.remove("select-box__option--selected")
    );
    const selectedOption = this.select.options[this.select.selectedIndex];
    if (selectedOption) {
      const fakeOptionElement = this.options.find(
        o => o.innerHTML === selectedOption.innerHTML
      );
      if (fakeOptionElement) {
        fakeOptionElement.classList.add("select-box__option--selected");
      }
    }

    this.block.classList.add("select-box--active");

    window.addEventListener("click", this.handleWindowClick, true);
  };
  close = () => {
    this.block.classList.remove("select-box--active");

    window.removeEventListener("click", this.handleWindowClick, true);
  };

  closeAllSelectBoxes = () => {
    const allSelectBoxes = [...document.querySelectorAll(".select-box--open")];

    allSelectBoxes
      .filter(sb => sb !== this.block)
      .forEach(sb => {
        sb.classList.remove("select-box--open");
      });
  };

  handleDisplayClick = e => {
    // avoid click on underneath select
    e.stopPropagation();

    // close all the other select boxes
    this.closeAllSelectBoxes();

    if (this.block.classList.contains("select-box--active")) {
      this.close();
    } else {
      this.open();
    }
  };
  handleFakeOptionClick = e => {
    // get clicked option and its value
    const fakeOptionElement = e.currentTarget;
    const optionValue = fakeOptionElement.dataset.value;

    if (!this.multiple) {
      // update native select box
      this.select.selectedIndex = this.nativeOptions.findIndex(
        o => o.value === optionValue
      );

      // update display element (the selected value shown)
      this.display.innerText =
        this.select.selectedIndex >= 0
          ? fakeOptionElement.innerText.trim()
          : this.nativeOptions.length
            ? this.nativeOptions[0].innerText.trim()
            : "--";

      // update set the current fake option as selected and unselect the others
      this.options.forEach(o =>
        o.classList.remove("select-box__option--selected")
      );
      fakeOptionElement.classList.add("select-box__option--selected");
    } else {
      if (optionValue == 'all') {
        const isAllSelected = this.nativeOptions.find(opt => optionValue === opt.value).selected;
        this.nativeOptions.forEach(opt => {
          opt.selected = !isAllSelected;
        });
        this.options.forEach(o => {
          o.querySelector("input").checked = !isAllSelected;
        });
      } else {
        this.nativeOptions.forEach(opt => {

          if (optionValue === opt.value) {
            opt.selected = !opt.selected;
            fakeOptionElement.querySelector("input").checked = opt.selected;
            if (!opt.selected) {
              this.nativeOptions.find(o => o.value === 'all').selected = false;
              this.options.find(o => o.dataset.value === 'all').querySelector("input").checked = false;
            }
          }
        });
      }
      const selectedItems = this.block.querySelector(
        ".select-box__multiple-selection"
      );
      selectedItems.innerHTML = "";
      this.options.forEach(opt => {
        if (opt.dataset.value === 'all') {
          return;
        }
        const input = opt.querySelector("input");
        if (input.checked) {

          const tag = document.createElement("div");
          tag.classList.add("select-box__selected-item");
          tag.innerText = opt.innerText.trim();
          tag.addEventListener("click", () => {
            opt.click();
          });
          selectedItems.appendChild(tag);
        }
      });

      if (this.select.selectedOptions.length === 0 && this.placeholder) {
        this.display.innerText = this.placeholder;
      } else {
        this.display.innerText = `${this.select.selectedOptions.length} option${this.select.selectedOptions.length != 1 ? "s" : ""
          } selected`;
      }
    }

    // fire change event on native select (it is not fired when change its value
    // programmatically)
    if ("createEvent" in document) {
      const event = document.createEvent("HTMLEvents");
      event.initEvent("change", false, true);
      this.select.dispatchEvent(event);
    } else {
      this.select.fireEvent("onchange");
    }

    this.close();

    if ("createEvent" in document) {
      const event = document.createEvent("HTMLEvents");
      event.initEvent("blur", false, true);
      this.select.dispatchEvent(event);
    } else {
      this.select.fireEvent("onblur");
    }
  };

  handleWindowClick = e => {
    const closestSelectBox = e.target.closest(".select-box");

    if (closestSelectBox === this.block) {
      return;
    }

    this.close();
  };

  // Lifecycle methods
  onReady() {
    // init display element (where the selected value is shown)
    this.display.addEventListener("click", this.handleDisplayClick);

    // init fake options list
    this.options.forEach(o => {
      o.addEventListener("click", this.handleFakeOptionClick);
    });

    if (!this.multiple) {
      this.options.forEach(opt => {
        if (opt.dataset.value === this.select.value) {
          this.display.innerText = opt.innerText.trim();
          opt.classList.add("select-box__option--selected");
        }
      });
    } else {
      if (this.select.selectedOptions.length === 0 && this.placeholder) {
        this.display.innerText = this.placeholder;
      } else {
        this.display.innerText = `${this.select.selectedOptions.length} option${this.select.selectedOptions.length != 1 ? "s" : ""
          } selected`;
      }
      const selectedValues = [...this.select.selectedOptions].map(
        opt => opt.value
      );
      const selectedItems = this.block.querySelector(
        ".select-box__multiple-selection"
      );
      selectedItems.innerHTML = "";
      this.options.forEach(opt => {
        const input = opt.querySelector("input");
        input.checked = selectedValues.includes(opt.dataset.value);
        if (input.checked) {
          const tag = document.createElement("div");
          tag.classList.add("select-box__selected-item");
          tag.innerText = opt.innerText.trim();
          tag.addEventListener("click", () => {
            opt.click();
          });
          selectedItems.appendChild(tag);
        }
      });
    }
  }
  onResize() { }
  onScroll() { }
  onDestroy = () => {
    // destroy display element (where the selected value is shown)
    this.display.removeEventListener("click", this.handleDisplayClick);

    // destroy fake options list
    this.options.forEach(o => {
      o.removeEventListener("click", this.handleFakeOptionClick);
    });

    window.removeEventListener("click", this.handleWindowClick, true);
  };
}
